import React, { useState } from 'react';
import axios from 'axios';

import { CustomButton, CustomInput } from 'components';
import { externalCalibrationService, serialNumbersService } from 'services';

import './SearchPdfForm.scss';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../../constants/routes';
import { ExternalCalibration } from '../../interfaces';
import { SerialNumber } from '../../interfaces/serialNumber';

export const SearchPdfForm = () => {
  const [serialNumber, setSerialNumber] = useState<string>('');
  const [errMessage, setErrMessage] = useState('');
  const navigate = useNavigate();

  const generatePdf = async (sn: string) => {
    setErrMessage('');

    try {
      if (!sn) {
        setErrMessage('Please enter serial number');
        return;
      }

      const cal: ExternalCalibration =
        await externalCalibrationService.findBySerialNumber(sn);

      if (cal && cal.certificateNr)
        navigate(`${ROUTES.documents_overview}/${sn}/${cal.certificateNr}`);
      else if (cal) {
        navigate(`${ROUTES.documents_overview}/${sn}`);
      }
    } catch (e) {
      try {
        const serial: SerialNumber = await serialNumbersService.findSerial(sn);

        if (serial && serial.sn) {
          navigate(`${ROUTES.documents_overview}/${sn}`);
        } else {
          throw new Error('Serial number not found');
        }
      } catch (e) {
        if (e instanceof Error) setErrMessage(e.message);
        if (axios.isAxiosError(e) && e.response)
          setErrMessage(e.response.data?.message || 'Something went wrong');
      }
    }
  };

  return (
    <div className="search-pdf-form-container">
      <h1 className="search-pdf__header">Search by serial number</h1>

      <CustomInput
        value={serialNumber}
        onChange={(e) => setSerialNumber(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            generatePdf(serialNumber);
          }
        }}
        label="Enter serial number"
        placeholder="SN"
      />
      <CustomButton
        onClick={() => generatePdf(serialNumber)}
        text="Search"
        width="100%"
      />
      {errMessage && <div className="search-pdf__error">{errMessage}</div>}
    </div>
  );
};
